// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kr-c";
export var backButton = "_kr-4";
export var backIcon = "_kr-5";
export var chevronShortcut = "_kr-6";
export var container = "_kr-1";
export var editor = "_kr-8";
export var editorWrapper = "_kr-7";
export var prefix = "_kr-2";
export var searchIcon = "_kr-3";
export var suffix = "_kr-9";
export var suffixContent = "_kr-a";
export var suffixText = "_kr-b";
export var wrapper = "_kr-0";